import { defineStore } from 'pinia'

export const useScrollStore = defineStore({
  id: 'navigation',
  state: () => ({
    blockIndex: 'home',
    blockClicked: false
  }),
  actions: {
    setBlockIndex(index) {
      this.blockIndex = index
    },
    setBlockClicked(value) {
      this.blockClicked = value
    }
  }
})
